export const reportAbusePopupTranslations = {
  en: {
    reportAbuse: "Report Abuse",
    reportSubtitle: "Help us keep our community safe. Please specify what violates our guidelines.",
    reasonLabel: "Reason *",
    reasonPlaceholder: "Provide a reason for the report...",
    characterCount: "/500 characters",
    cancel: "Cancel",
    submit: "Submit",
    submit_success: "Report submitted",
    errorReasonRequired: "Please provide a reason.",
    errorReasonTooLong: "The reason must be 500 characters or less.",
  },
  de: {
    reportAbuse: "Missbrauchsbericht",
    reportSubtitle: "Helfen Sie uns, unsere Community sicher zu halten. Bitte geben Sie an, was gegen unsere Richtlinien verstößt.",
    reasonLabel: "Grund *",
    reasonPlaceholder: "Geben Sie einen Grund für die Meldung an...",
    characterCount: "/500 Zeichen",
    cancel: "Abbrechen",
    submit: "Einreichen",
    submit_success: "Bericht eingereicht",
    errorReasonRequired: "Bitte geben Sie einen Grund an.",
    errorReasonTooLong: "Der Grund darf nicht länger als 500 Zeichen sein.",
  },
  hr: {
    reportAbuse: "Izvještaj o zloupotrebi",
    reportSubtitle: "Pomozite nam očuvati sigurnost zajednice. Navedite što krši naša pravila.",
    reasonLabel: "Razlog *",
    reasonPlaceholder: "Navedite razlog za prijavu...",
    characterCount: "/500 znakova",
    cancel: "Odustani",
    submit: "Podnesi",
    submit_success: "Izvješće poslano",
    errorReasonRequired: "Molimo navedite razlog.",
    errorReasonTooLong: "Razlog mora biti kraći od 500 znakova.",
  },
};
